import React from "react";
import { ArrowUpOutlined, ArrowDownOutlined } from "@ant-design/icons";
import styles from "./VariationBadge.module.scss";
import {
  isVariationAvailable,
  variationNotAvailableLabel,
} from "../../helpers/VariationHelper";

interface VariationBadgeProps {
  value: number | null | undefined;
  suffix?: string;
}

const VariationBadge: React.FC<VariationBadgeProps> = ({ value, suffix = "%" }) => {
  if (!isVariationAvailable(value)) {
    return <span className={styles.neutral}>{variationNotAvailableLabel()}</span>;
  }
  const isPositive = value >= 0;
  return (
    <span className={`${styles.variation} ${isPositive ? styles.positive : styles.negative}`}>
      {isPositive ? <ArrowUpOutlined /> : <ArrowDownOutlined />}
      {" "}
      {isPositive ? "+" : ""}
      {value.toFixed(1)}
      {suffix}
    </span>
  );
};

export default VariationBadge;
